import {
  Currency,
  QueryGameHallResponseVendorType1,
  QueryVendorCurrencyInfoResponse,
  VendorBalanceList
} from "@/types/common"
import {
  getCurrencyDefaultOfQuickStakes,
  getCurrencyDefaultOfSymbol
} from "@/utils/currency"

export const useWalletStore = defineStore("wallet", () => {
  const isLoading = ref(false)
  const load = () => {
    isLoading.value = true
  }
  const unLoad = () => {
    isLoading.value = false
  }

  const authStore = useAuthStore()
  const player = computed(() => authStore.playerInfo)

  const isMultiWallet = computed(() => player.value.vendorQuantity > 0)

  const mainWallet = computed(() => ({
    money: player.value.betCredit,
    exposure: player.value.totalExposure,
    vendorQuantity: player.value.vendorQuantity
  }))

  const wallets = ref(new Map())

  const updateWithMultiWallet = (list: VendorBalanceList[]) => {
    list.forEach(vendor => {
      const { vendorSite } = vendor

      wallets.value.set(vendorSite, vendor)
    })
  }

  const currency = ref<Currency & { defaultChip: { amount: number; display: string }[] }>(
    {
      id: 0,
      rate: 1,
      type: "",
      symbol: "",
      minBet: 0,
      defaultChip: []
    }
  )

  const updateCurrency = (current: Currency) => {
    const chip = getCurrencyDefaultOfQuickStakes(current.id)
    const symbol = getCurrencyDefaultOfSymbol(current.id)

    const defaultChip = chip.reduce(
      (arr: { amount: number; display: string }[], node) => {
        const [amount, display] = node
        return [...arr, { amount, display }]
      },
      []
    )

    currency.value = {
      ...current,
      defaultChip,
      symbol: symbol!
    }
  }

  const fundTransferDetails: Ref<{
    vendor: Partial<QueryGameHallResponseVendorType1>
    details: Partial<QueryVendorCurrencyInfoResponse>
  }> = ref({
    vendor: {},
    details: {}
  })

  const updateFundTransferDetails = ({
    vendor,
    details
  }: {
    vendor: Partial<QueryGameHallResponseVendorType1>
    details: Partial<QueryVendorCurrencyInfoResponse>
  }) => {
    fundTransferDetails.value = {
      vendor,
      details
    }
  }

  const clearFundTransferDetails = () => {
    fundTransferDetails.value = {
      vendor: {},
      details: {}
    }
  }

  const handlerRefreshMoney = () => {
    if (isLoading.value) return

    load()

    setTimeout(() => {
      unLoad()
    }, 4 * 1000)
  }

  return {
    load,
    unLoad,
    mainWallet,
    wallets,
    isMultiWallet,
    isLoading,
    currency,
    fundTransferDetails,
    clearFundTransferDetails,
    updateFundTransferDetails,
    updateCurrency,
    handlerRefreshMoney,
    updateWithMultiWallet
  }
})

export default useWalletStore
